import styled from 'styled-components';

const ContentEditable = styled.span`
  color: var(--content-body);
  caret-color: var(--primary-default);
  outline: none;
`;

export { ContentEditable };
